module.exports = __webpack_public_path__ + "media/images/primary_next_page_icon-b9a3a37f356183f432d6c69829ddf521.svg";